import { FC } from 'react';
import { NavItem } from './types';
import s from './ContentNavigation.module.scss';
import cn from 'classnames';
import { HeadingV2 } from '../../_text/HeadingV2';

interface Props {
	navItems: NavItem[];
	activeItem: NavItem;
	setActiveItem: (id: NavItem) => void;
}

export const ContentNavigation: FC<Props> = (props) => {
	const {
		navItems, //
		activeItem,
		setActiveItem,
	} = props;

	const rest = [...navItems];
	const first = rest.shift();

	return (
		<ul className={s.container}>
			{first && (
				<li
					key={first.id}
					className={cn(s.item, activeItem.id === first.id && s.item__active)}
					onClick={() => setActiveItem(first)}
				>
					{first.id}
				</li>
			)}

			<div className={s.separator}>
				<HeadingV2 type={'h4_medium'}>Areas of potential improvement</HeadingV2>

				<hr />
			</div>

			{rest.map((navItem, index) => (
				<li
					key={index + 1}
					className={cn(s.item, activeItem.id === navItem.id && s.item__active)}
					onClick={() => setActiveItem(navItem)}
				>
					{index + 1 + '. ' + navItem.id}
				</li>
			))}
		</ul>
	);
};
